/* src/app/job-signoff-start/pages/job-signoff-start/job-signoff-start.component.scss */
/*# sourceMappingURL=job-signoff-start.component.css.map */
